export default __webpack_public_path__ + "static/media/Esmax-40-eng.06d1c7a3.jpg";